import { PixelCrop } from 'react-image-crop';

const TO_RADIANS = Math.PI / 180;

export const rotateImage = (image: HTMLImageElement, type?: string) => {
  const canvas = document.createElement('canvas');
  const { naturalHeight: height, naturalWidth: width } = image;

  canvas.width = height;
  canvas.height = width;

  const ctx = canvas.getContext('2d');

  if (!ctx) {
    throw new Error('No 2d ctx');
  }

  ctx.clearRect(0, 0, width, height);
  ctx.translate(height / 2, width / 2);
  ctx.rotate(-90 * TO_RADIANS);
  ctx.drawImage(image, -width / 2, -height / 2);
  return canvas.toDataURL(type, 0.8);
};

export const canvasPreview = (
  image: HTMLImageElement,
  crop: PixelCrop,
  scale = 1,
  rotate = 0,
) => {
  const canvas = document.createElement('canvas');
  const { naturalWidth, naturalHeight, width, height } = image;
  const ctx = canvas.getContext('2d');

  if (!ctx) {
    throw new Error('No 2d context');
  }

  const scaleX = naturalWidth / width;
  const scaleY = naturalHeight / height;
  const pixelRatio = window.devicePixelRatio || 1;
  // const pixelRatio = 1

  canvas.width = Math.floor(crop.width * scaleX * pixelRatio);
  canvas.height = Math.floor(crop.height * scaleY * pixelRatio);

  ctx.scale(pixelRatio, pixelRatio);
  ctx.imageSmoothingQuality = 'high';

  const cropX = crop.x * scaleX;
  const cropY = crop.y * scaleY;

  const rotateRads = rotate * TO_RADIANS;
  const centerX = naturalWidth / 2;
  const centerY = naturalHeight / 2;

  ctx.save();

  // 5) Move the crop origin to the canvas origin (0,0)
  ctx.translate(-cropX, -cropY);
  // 4) Move the origin to the center of the original position
  ctx.translate(centerX, centerY);
  // 3) Rotate around the origin
  ctx.rotate(rotateRads);
  // 2) Scale the image
  ctx.scale(scale, scale);
  // 1) Move the center of the image to the origin (0,0)
  ctx.translate(-centerX, -centerY);
  ctx.drawImage(
    image,
    0,
    0,
    naturalWidth,
    naturalHeight,
    0,
    0,
    naturalWidth,
    naturalHeight,
  );

  return canvas.toDataURL();
};

export const randomId = () => (Math.random() + 1).toString(36).substring(7);
